function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import React, { useEffect, useState } from 'react';
import sortBy from 'lodash/sortBy';
import capitalize from 'lodash/capitalize';
import cloneDeep from 'lodash/cloneDeep';
import { DigestTrackingEvent, SaveNewDigestUiLocation, track } from 'common/query-builder/query-report-header/subscribe-to-boards-menu/tracking';
import { getUsers, LoadingState, SubscribeToBoardsMenuReact } from 'common/query-builder/query-report-header/subscribe-to-boards-menu';
import { DashboardDigest, DigestRecurrence, DigestType, LoadingStatus, ProjectMember, SerializedDashboardDigest } from 'common/query-builder/query-report-header/subscribe-to-boards-menu/types';
import { getDigestTrackingData, isAsapDigest, isEmailDigest } from 'common/query-builder/query-report-header/subscribe-to-boards-menu/util';
import { confirm } from 'common/components/confirm';
import { DIGEST_COPY } from 'common/query-builder/query-report-header/subscribe-to-boards-menu/constants';
import { THEME as ConfirmTheme } from 'common/components/confirm/types';
import { ModalReact } from 'common/components/modal';
import { Visibility } from 'common/components/base/stackable';
import { apiClient } from 'common/util/api-client';
import { reporter } from 'common/report/error-reporting';
import { addToast } from 'common/components/toast-area/toast-manager';
import { ToastType } from 'common/components/toast/types';
import { FilterSelectConfig } from 'common/components/filter-bar/types';
import { SectionItem } from 'common/components/items-menu/types';
import { SelectChangeEvent } from 'common/components/filter-bar-table/types';
import { FilterBarReact } from 'common/components/filter-bar';
import filterBarStyleOverride from 'apps/boards/src/dashboards-app/manage-digests-mode/subscriptions-page/filter-bar.inline.styl';
import { InputReact } from 'common/components/input';
import { InputSize } from 'common/components/input/types';
import { SelectReact } from 'common/components/select';
import { Directions } from 'common/components/drop-menu/types';
import { SelectTheme } from 'common/components/select/constants';
import { TableReact } from 'common/components/table';
import tableCss from 'apps/boards/src/dashboards-app/manage-digests-mode/table.module.styl';
import { react2panel } from 'common/util/react2panel';
import styles from 'apps/boards/src/dashboards-app/manage-digests-mode/subscriptions-page/index.module.styl';
import { CellDigestCreatorPanel, CellDigestDashboardPanel, CellDigestRecipientsPanel, SubscribeToExistingDigestButtonPanel } from 'apps/boards/src/dashboards-app/manage-digests-mode/subscriptions-page/util';
import { DashboardsContext } from 'apps/boards/src/util/context';
import { DashboardSelectorController } from 'common/report/controllers/dashboard-selector-controller';
import { Permission } from 'common/report/constants';
import { useCurrentUser } from 'common/contexts/react/current-user-context';
import { useReportLayoutManager } from 'common/contexts/react/report-layout-manager-context';
import { Translatable } from 'common/i18n';
import { useTranslation } from 'common/i18n/hooks';
enum FILTERS {
  BoardFilter = "board-filter",
  CreatorFilter = "creator-filter",
  FrequencyFilter = "frequency-filter",
  TypeFilter = "type-filter",
}
enum DigestTypeOption {
  Any = "Any type",
  Email = "Email",
  Slack = "Slack",
}
const DigestTypeOptionLabel: { [k in DigestTypeOption]: Translatable } = {
  [DigestTypeOption.Any]: _ref => {
    let {
      t
    } = _ref;
    return t("subscriptions.alert-any");
  },
  [DigestTypeOption.Email]: _ref2 => {
    let {
      t
    } = _ref2;
    return t("subscriptions.alert-email");
  },
  [DigestTypeOption.Slack]: _ref3 => {
    let {
      t
    } = _ref3;
    return t("subscriptions.alert-slack");
  }
};
enum FrequencyOption {
  Any = "Any frequency",
  Daily = "Daily",
  Weekly = "Weekly",
  Monthly = "Monthly",
}
const FrequencyOptionLabel: { [k in FrequencyOption]: Translatable } = {
  [FrequencyOption.Any]: _ref4 => {
    let {
      t
    } = _ref4;
    return t("subscriptions.repeat-any");
  },
  [FrequencyOption.Daily]: _ref5 => {
    let {
      t
    } = _ref5;
    return t("subscriptions.repeat-daily");
  },
  [FrequencyOption.Weekly]: _ref6 => {
    let {
      t
    } = _ref6;
    return t("subscriptions.repeat-weekly");
  },
  [FrequencyOption.Monthly]: _ref7 => {
    let {
      t
    } = _ref7;
    return t("subscriptions.repeat-monthly");
  }
};

// Need this to convert from string to Recurrence values backing actual data model for digests
const frequencyOptionToRecurrence = {
  [FrequencyOption.Daily]: DigestRecurrence.Daily,
  [FrequencyOption.Weekly]: DigestRecurrence.Weekly,
  [FrequencyOption.Monthly]: DigestRecurrence.Monthly
};
const DIGEST_TYPE_OPTIONS = [DigestTypeOption.Any, DigestTypeOption.Email, DigestTypeOption.Slack];
const FREQUENCY_OPTIONS = [FrequencyOption.Any, FrequencyOption.Daily, FrequencyOption.Weekly, FrequencyOption.Monthly];
const ANY_BOARDS = "Any board";
const ANY_BOARDS_LABEL = _ref8 => {
  let {
    t
  } = _ref8;
  return t("subscriptions.any-board");
};
const ANY_CREATOR = "Any creator";
const ANY_CREATOR_LABEL = _ref9 => {
  let {
    t
  } = _ref9;
  return t("subscriptions.any-creator");
};
type SubscriptionsPageProps = {
  context: DashboardsContext;
  selectorController: DashboardSelectorController;
};
type Row = {
  creator: string;
  dashboard: string;
  frequency: string;
  id: number;
  isRowClickDisabled?: boolean;
  isSubscribed: boolean;
  model: DashboardDigest;
  name: string;
  recipients: string[];
  schedule: string;
  status: string;
  type: string;
  workspaceName: string;
};
const getStandardAppApiUrl = (projectId: number, workspaceId?: number) => {
  const parentEntityPath = workspaceId ? "workspaces/".concat(workspaceId) : "projects/".concat(projectId);
  return "/api/app/".concat(parentEntityPath);
};
const getDigestApiUrl = function getDigestApiUrl(projectId: number, workspaceId?: number): string {
  let digestId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  return "".concat(getStandardAppApiUrl(projectId, workspaceId), "/dashboard-reports/email-digests/").concat(digestId);
};
const UpdateDigestModal = (props: {
  digest: DashboardDigest;
  trackFunc: (event: DigestTrackingEvent, digest?: Partial<DashboardDigest> | Partial<SerializedDashboardDigest>) => void;
  projectId: number;
  workspaceId?: number;
  availableMembers: LoadingState<ProjectMember[]>;
  projectTimezone: string;
  addOrUpdateDigestInList: (digest: DashboardDigest) => void;
  setDigestToUpdate: (digest: DashboardDigest | null) => void;
  deleteDigestFromList: (digestId: number) => void;
}) => {
  return <ModalReact className={styles.mpModal} open closeable onChange={(event: CustomEvent) => {
    if (event.detail.state === Visibility.Closed) {
      props.setDigestToUpdate(null);
      props.trackFunc(DigestTrackingEvent.CloseEditDigestBuilder);
    }
  }} data-sentry-element="ModalReact" data-sentry-component="UpdateDigestModal" data-sentry-source-file="index.tsx">
      <header className={styles.modalHeader}>Manage Subscription</header>
      <SubscribeToBoardsMenuReact createOnly deleteDigestCallback={digestId => {
      props.deleteDigestFromList(digestId);
    }} digestToUpdate={props.digest} members={props.availableMembers} projectId={props.projectId} workspaceId={props.workspaceId} updateDigestCallback={digest => {
      props.addOrUpdateDigestInList(digest);
    }} projectTimezone={props.projectTimezone} onCloseCallback={() => {
      props.setDigestToUpdate(null);
      props.trackFunc(DigestTrackingEvent.CloseEditDigestBuilder);
    }} data-sentry-element="SubscribeToBoardsMenuReact" data-sentry-source-file="index.tsx" />
    </ModalReact>;
};
export function SubscriptionsPage(props: SubscriptionsPageProps) {
  var _currentUser$get$valu;
  const currentUser = useCurrentUser();
  const reportLayoutManager = useReportLayoutManager();
  const i18n = useTranslation();
  const [availableMembers, setAvailableMembers] = useState<LoadingState<ProjectMember[]>>({
    loading: LoadingStatus.Idle,
    data: null,
    error: null
  });
  const [createNewMenuIsOpen, setCreateNewMenuIsOpen] = useState<boolean>(false);
  const [creatorIdFilter, setCreatorIdFilter] = useState<string | number>(ANY_CREATOR);
  const [dashboardIdFilter, setDashboardIdFilter] = useState<string | number>(ANY_BOARDS);
  const [digests, setDigests] = useState<LoadingState<DashboardDigest[]>>({
    loading: LoadingStatus.Idle,
    data: null,
    error: null
  });
  const [digestIsBeingUpdatedMap, setDigestIsBeingUpdatedMap] = useState<Map<number, boolean>>(new Map());
  const [digestsSearchFilter, setDigestsSearchFilter] = useState<string>("");
  const [frequencyFilter, setFrequencyFilter] = useState<FrequencyOption>(FrequencyOption.Any);
  const [membersMap, setMembersMap] = useState<Map<string, ProjectMember>>(new Map());
  const [typeFilter, setTypeFilter] = useState<DigestTypeOption>(DigestTypeOption.Any);
  const [digestToUpdate, setDigestToUpdate] = useState<DashboardDigest | null>(null);
  const projectId = props.context.projectId;
  const workspaceId = props.context.workspaceId;
  const projectTimezone = props.context.projectTimezone;
  const canAccessDigests = props.context.permissions.has(Permission.AccessDashboardEmailDigests);
  useEffect(() => {
    getUsers(projectId).then(res => {
      setAvailableMembers(res);
      setMembersMap(new Map(res.data.map(x => [x.email, x])));
    });
    reportLayoutManager.updateWhiteBackBackground(true);
    if (!props.context) {
      throw new Error("\"context\" is a required component prop");
    }
    if (!props.selectorController) {
      throw new Error("\"selectorController\" is a required component prop");
    }
    if (!projectId) {
      throw new Error("\"projectId\" is a required component prop");
    }

    // Need this to get context.permissions
    props.context.loadUserInfo();
    props.selectorController.resetActiveDashboard();
    props.context.initializeTracking();
    props.context.track(DigestTrackingEvent.ViewedDigestControlCenter);
    getDigests({
      projectId,
      workspaceId
    });
  }, []);
  useEffect(() => {
    return () => {
      reportLayoutManager.updateWhiteBackBackground(false);
    };
  }, []);
  const currentUserEmail = (_currentUser$get$valu = currentUser.get().value) === null || _currentUser$get$valu === void 0 ? void 0 : _currentUser$get$valu.email;
  const canEditDigest = (creatorEmail: string) => creatorEmail === currentUserEmail || props.context.permissions.has(Permission.EditLockedEntity);
  async function getDigests(): Promise<void> {
    let options: {
      projectId?: number;
      workspaceId?: number;
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    setDigests(x => _objectSpread(_objectSpread({}, x), {}, {
      loading: LoadingStatus.Pending
    }));
    try {
      const allDigests = await apiClient.get<DashboardDigest[]>(getDigestApiUrl(options.projectId, options.workspaceId));
      // Make sure to never show asap digests in the UI
      const data = allDigests.filter(digest => !isAsapDigest(digest));
      setDigests(x => _objectSpread(_objectSpread({}, x), {}, {
        loading: LoadingStatus.Success,
        data
      }));
      setDigestIsBeingUpdatedMap(new Map());
    } catch (err) {
      reporter.error(err, "Failed to fetch subscriptions.");
      setDigests(x => {
        return _objectSpread(_objectSpread({}, x), {}, {
          loading: LoadingStatus.Failed,
          error: err
        });
      });
      addToast({
        message: "Failed to fetch subscriptions.",
        type: ToastType.ERROR,
        isStatic: false
      });
    }
  }
  function getFilters(): FilterSelectConfig[] {
    var _digests$data;
    const currDigests = (_digests$data = digests.data) !== null && _digests$data !== void 0 ? _digests$data : [];
    const boardItems: SectionItem[] = Object.values(currDigests.reduce((map, digest) => {
      if (!map[digest.dashboard_id]) {
        map[digest.dashboard_id] = {
          label: digest.dashboard_title,
          isSelected: digest.dashboard_id === dashboardIdFilter,
          value: digest.dashboard_id
        };
      }
      return map;
    }, {} as Record<string, SectionItem>)
    // Empty dashboards titles can cause this list to be filled up with nothing at the top and look broken
    ).filter(item => Boolean(item.label));
    const creatorItems: SectionItem[] = Object.values(currDigests.reduce((map, digest) => {
      if (!map[digest.creator_id]) {
        map[digest.creator_id] = {
          label: digest.creator_email,
          isSelected: digest.creator_id === creatorIdFilter,
          value: digest.creator_id
        };
      }
      return map;
    }, {} as Record<string, SectionItem>));
    return [{
      name: FILTERS.BoardFilter,
      menuWidth: 400,
      defaultFilterLabel: ANY_BOARDS,
      sections: [{
        items: [{
          label: ANY_BOARDS_LABEL,
          isSelected: dashboardIdFilter === ANY_BOARDS,
          value: ANY_BOARDS
        }, ...sortBy(boardItems, [item => item.label.toString().toLowerCase()])]
      }]
    }, {
      name: FILTERS.CreatorFilter,
      menuWidth: 400,
      defaultFilterLabel: ANY_CREATOR,
      sections: [{
        items: [{
          label: ANY_CREATOR_LABEL,
          isSelected: creatorIdFilter === ANY_CREATOR,
          value: ANY_CREATOR
        }, ...sortBy(creatorItems, [item => item.label.toString().toLowerCase()])]
      }]
    }, {
      name: FILTERS.FrequencyFilter,
      defaultFilterLabel: FrequencyOption.Any,
      sections: [{
        items: FREQUENCY_OPTIONS.map(frequency => ({
          label: i18n.print(FrequencyOptionLabel[frequency]),
          value: frequency,
          isSelected: frequencyFilter === frequency
        }))
      }]
    }, {
      name: FILTERS.TypeFilter,
      defaultFilterLabel: DigestTypeOption.Any,
      sections: [{
        items: DIGEST_TYPE_OPTIONS.map(digestType => ({
          label: i18n.print(DigestTypeOptionLabel[digestType]),
          value: digestType,
          isSelected: typeFilter === digestType
        }))
      }]
    }];
  }
  function getFilteredDigests(): DashboardDigest[] {
    var _digests$data2;
    const currDigests = (_digests$data2 = digests.data) !== null && _digests$data2 !== void 0 ? _digests$data2 : [];
    return currDigests.filter(digest => {
      if (dashboardIdFilter !== ANY_BOARDS && digest.dashboard_id !== dashboardIdFilter) {
        return false;
      }
      if (creatorIdFilter !== ANY_CREATOR && digest.creator_id !== creatorIdFilter) {
        return false;
      }
      if (frequencyFilter !== FrequencyOption.Any && digest.recur !== frequencyOptionToRecurrence[frequencyFilter]) {
        return false;
      }
      if (typeFilter !== DigestTypeOption.Any) {
        if (typeFilter === DigestTypeOption.Email && !isEmailDigest(digest)) {
          return false;
        }
        if (typeFilter === DigestTypeOption.Slack && isEmailDigest(digest)) {
          return false;
        }
      }
      return true;
    });
  }
  function getRecipientsFromDigest(digest: DashboardDigest) {
    if (isEmailDigest(digest)) {
      return digest.recipients;
    }
    return digest.slack_subscriptions.map(sub => "#".concat(sub.slack_channel_name));
  }
  function handleFilterChanged(event: SelectChangeEvent): void {
    const {
      detail
    } = event;
    const newVal = detail.item && detail.item.value || detail.value;
    switch (detail.name) {
      case FILTERS.BoardFilter:
        setDashboardIdFilter(newVal);
        break;
      case FILTERS.CreatorFilter:
        setCreatorIdFilter(newVal);
        break;
      case FILTERS.FrequencyFilter:
        setFrequencyFilter(newVal as FrequencyOption);
        break;
      case FILTERS.TypeFilter:
        setTypeFilter(newVal as DigestTypeOption);
        break;
    }
  }
  const handleSearchInputChange = (inputString: string) => setDigestsSearchFilter(inputString);
  function track2(event: DigestTrackingEvent, digest?: Partial<DashboardDigest> | Partial<SerializedDashboardDigest>) {
    let data: Record<string, any> = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    track(event, _objectSpread(_objectSpread({
      isNewSubscriptionsUi: true,
      // Right now this is a 1:1 match but this could potentially become incorrect
      'ui location': SaveNewDigestUiLocation.SubscriptionsPage
    }, data), digest ? getDigestTrackingData(digest, membersMap, i18n) : {}));
  }

  /**
   * Much of the below code is copied from manage-digests-mode/index.ts for speed of iteration and to avoid decoupling.
   */

  function handleDigestApiError(err: any, toastMessage: Translatable): void {
    reporter.error(err);
    addToast({
      message: toastMessage || err.message,
      type: ToastType.ERROR
    });
  }
  function getSerializedDigestFromDigest(digest: DashboardDigest): SerializedDashboardDigest {
    return {
      monthly_week_ordinal: digest.monthly_week_ordinal,
      recur: digest.recur,
      // @ts-ignore digest.start_date is a string
      start_date: digest.start_date as string,
      timezone: digest.timezone,
      slack_subscriptions: digest.slack_subscriptions,
      recipients: digest.recipients,
      dashboard_id: digest.dashboard_id
    };
  }
  function addOrUpdateDigestInList(digest: DashboardDigest) {
    setDigests(x => {
      const draft = _objectSpread({}, x);
      const existingDigestIndex = draft.data.findIndex(d => d.id === digest.id);
      if (existingDigestIndex > -1) {
        draft.data[existingDigestIndex] = digest;
      } else {
        draft.data.push(digest);
      }
      return draft;
    });
  }
  function deleteDigestFromList(digestId: number) {
    setDigests(x => {
      const draft = _objectSpread({}, x);
      const indexOf = draft.data.findIndex(d => d.id === digestId);
      draft.data.splice(indexOf, 1);
      return draft;
    });
  }
  async function patchDigest(digest: DashboardDigest): Promise<void> {
    const serializedDigest = getSerializedDigestFromDigest(digest);
    return apiClient.patch<DashboardDigest>(getDigestApiUrl(digest.project_id, digest.workspace_id, digest.id.toString()), serializedDigest).then(res => {
      track2(DigestTrackingEvent.EditDigest, serializedDigest);
      addToast({
        message: DIGEST_COPY.updateDigestSuccess,
        type: ToastType.SUCCESS
      });
      addOrUpdateDigestInList(res);
    }).catch(err => handleDigestApiError(err, DIGEST_COPY.updateDigestError));
  }
  async function deleteDigest(digest: DashboardDigest) {
    return apiClient.delete<DashboardDigest>(getDigestApiUrl(digest.project_id, digest.workspace_id, digest.id.toString())).then(() => {
      deleteDigestFromList(digest.id);
      addToast({
        message: DIGEST_COPY.deleteDigestSuccess,
        type: ToastType.DESTRUCTIVE
      });
    }).catch(err => handleDigestApiError(err, DIGEST_COPY.deleteDigestError));
  }
  function onCreateMenuOpenChange(isOpen: boolean) {
    if (isOpen) {
      track2(DigestTrackingEvent.OpenNewDigestBuilder);
    } else {
      track2(DigestTrackingEvent.CloseNewDigestBuilder);
    }
    setCreateNewMenuIsOpen(isOpen);
  }
  async function onSubscribeToExistingDigest(digest: DashboardDigest, currentUserIsSubscribedToDigest: boolean) {
    track2(DigestTrackingEvent.SubscriptionInlineSubUnsubButton, digest, {
      'sub/unsub': currentUserIsSubscribedToDigest ? "unsubscribe" : "subscribe"
    });
    const setUpdatingState = (isUpdating: boolean) => {
      setDigestIsBeingUpdatedMap(x => {
        const draft = cloneDeep(x);
        draft.set(digest.id, isUpdating);
        return draft;
      });
    };

    // If they are the last subscriber and they want to remove themselves we
    // will instead delete the digest. We need to confirm this is what the user
    // wants.
    if (currentUserIsSubscribedToDigest && digest.recipients.length === 1) {
      if (await confirm({
        theme: ConfirmTheme.DELETE,
        title: i18n.print(DIGEST_COPY.deleteDigestTitle)
      }, {}, {
        confirmButtonLabel: _ref10 => {
          let {
            t
          } = _ref10;
          return t("common.delete");
        },
        description: DIGEST_COPY.removingFinalSubscriberWillDeleteDigestPrompt
      })) {
        setUpdatingState(true);
        await deleteDigest(digest);
        setUpdatingState(false);
      }
      return;
    }
    setUpdatingState(true);
    const updatedRecipients = currentUserIsSubscribedToDigest ? digest.recipients.filter(email => email !== currentUserEmail) : digest.recipients.concat(currentUserEmail);
    await patchDigest(_objectSpread(_objectSpread({}, digest), {}, {
      recipients: updatedRecipients
    }));
    setUpdatingState(false);
  }
  function openDigestEditDialog(digest: DashboardDigest) {
    setDigestToUpdate(digest);
  }
  const digestsLoading = [LoadingStatus.Idle, LoadingStatus.Pending].includes(digests.loading);
  const filteredDigests = getFilteredDigests();
  const resultCountString: string = digestsLoading ? i18n.t("common.loading") : i18n.t("subscriptions.count-subscriptions", {
    count: filteredDigests.length
  });
  return <div data-sentry-component="SubscriptionsPage" data-sentry-source-file="index.tsx">
      <div className={styles.pageTitle}>{i18n.t("subscriptions.title")}</div>
      <div className={styles.pageHeader}>
        <FilterBarReact resultCount={resultCountString} filters={getFilters()}
      // @ts-ignore
      styleOverride={filterBarStyleOverride} onChangeFilter={event => handleFilterChanged(event)} data-sentry-element="FilterBarReact" data-sentry-source-file="index.tsx" />
        <InputReact className={styles.searchInput} icon={"search"} placeholder={i18n.t("subscriptions.search-all-placeholder")} size={InputSize.Medium} onInput={ev => handleSearchInputChange(ev.target.value)} data-sentry-element="InputReact" data-sentry-source-file="index.tsx" />
        <SelectReact label={i18n.t("subscriptions.create-new")} menuWidth={200} menuAlignment={Directions.DownRight} neverShowCaret open={createNewMenuIsOpen} preventClose theme={SelectTheme.Primary} onMenuChange={event => onCreateMenuOpenChange(event.detail.isOpen)} data-sentry-element="SelectReact" data-sentry-source-file="index.tsx">
          <div slot={"body"} className={styles.subscribeMenu}>
            {projectId && availableMembers.data ? <SubscribeToBoardsMenuReact createOnly isOpen={createNewMenuIsOpen} members={availableMembers} projectId={projectId} workspaceId={workspaceId} projectTimezone={projectTimezone} createDigestCallback={digest => {
            addOrUpdateDigestInList(digest);
          }} onCloseCallback={() => setCreateNewMenuIsOpen(false)} /> : null}
          </div>
        </SelectReact>
      </div>

      <TableReact className={styles.table} trackName={"dashboard-digests"} disableClickableRows={!canAccessDigests} defaultSortField={"name"} loading={digestsLoading} searchFilter={digestsSearchFilter}
    // @ts-ignore
    styleOverride={tableCss} windowScroll onRowClick={_ref11 => {
      let {
        detail
      } = _ref11;
      return canAccessDigests && canEditDigest(detail.row.creator) ? openDigestEditDialog(detail.row.model) : null;
    }} rows={filteredDigests.map(digest => {
      const row: Row = {
        creator: digest.creator_email,
        dashboard: digest.dashboard_foreign_private ? "Unknown private board" : digest.dashboard_title,
        frequency: DigestRecurrence[digest.recur],
        id: digest.id,
        isSubscribed: digest.recipients.includes(currentUserEmail),
        model: digest,
        name: digest.name,
        recipients: getRecipientsFromDigest(digest),
        schedule: digest.schedule,
        status: digest.status,
        type: capitalize(isEmailDigest(digest) ? DigestType.Email : DigestType.Slack),
        workspaceName: digest.workspace_name
      };
      return row;
    })} columns={[{
      title: i18n.t("subscriptions.column.board"),
      field: "dashboard",
      isSearchable: true,
      isSortable: true,
      flexGrow: "6",
      cellRenderer: (row, context) => CellDigestDashboardPanel(row, context)
    }, workspaceId ? {
      title: i18n.t("subscriptions.column.data-view"),
      field: "workspaceName",
      isSearchable: true,
      isSortable: true,
      flexGrow: "4"
    } : null, {
      title: i18n.t("subscriptions.column.type"),
      field: "type",
      isSearchable: true,
      isSortable: true,
      flexGrow: "2"
    }, {
      title: i18n.t("subscriptions.column.schedule"),
      field: "schedule",
      isSearchable: true,
      isSortable: true,
      flexGrow: "6"
    }, {
      title: i18n.t("subscriptions.column.creator"),
      field: "creator",
      isSearchable: true,
      isSortable: true,
      flexGrow: "2",
      cellRenderer: (row: Row) => CellDigestCreatorPanel(row, membersMap)
    }, {
      title: i18n.t("subscriptions.column.subscribers"),
      field: "recipients",
      isSearchable: true,
      isSortable: false,
      flexGrow: "4",
      cellRenderer: row => CellDigestRecipientsPanel(row, membersMap)
    }, {
      title: i18n.t("subscriptions.column.subscribed"),
      field: "isSubscribed",
      isSearchable: false,
      isSortable: true,
      flexGrow: "2",
      flexBasis: "80px",
      cellRenderer: row => {
        return isEmailDigest(row.model) && SubscribeToExistingDigestButtonPanel(row.model, row.isSubscribed, digestIsBeingUpdatedMap, currentUser.get().value, onSubscribeToExistingDigest, canAccessDigests);
      }
    }].filter(Boolean)} data-sentry-element="TableReact" data-sentry-source-file="index.tsx" />

      {digestToUpdate ? <UpdateDigestModal digest={digestToUpdate} trackFunc={track2} projectId={projectId} workspaceId={workspaceId} availableMembers={availableMembers} projectTimezone={projectTimezone} addOrUpdateDigestInList={addOrUpdateDigestInList} setDigestToUpdate={setDigestToUpdate} deleteDigestFromList={deleteDigestFromList} /> : null}
    </div>;
}
export const SubscriptionsPageEl = react2panel("mp-subscriptions-page", SubscriptionsPage);
export const SubscriptionsPageReact = SubscriptionsPage;